export default "__VITE_ASSET__mHfsGacQ__"